import {EuiFlexGroup, EuiFlexItem} from "@elastic/eui";
import {Header} from "./Header";
import {Footer} from "./Footer";
import React from "react";
import {Outlet} from "react-router-dom";

export const Root: React.FC = () => {
    return (
        <EuiFlexGroup direction={"column"} style={{'height': '100%'}}>
            <EuiFlexItem grow={false}>
                <Header />
            </EuiFlexItem>
            <EuiFlexItem style={{overflow: "auto"}} id={"bodyContentId"}>
                <Outlet />
            </EuiFlexItem>
            <EuiFlexItem grow={false}>
                <Footer />
            </EuiFlexItem>
        </EuiFlexGroup>
    )
}